(function () {
  const MODAL_ID = 'snize-modal-mobile-filters-dialog';

  const path = window.location.pathname;

  const shouldRun =
    path.startsWith('/collections') ||
    path.startsWith('/search') ||
    path === '/pages/shop' ||
    path === '/pages/shop-all' ||
    path === '/pages/search-results-page';

  if (!shouldRun) return;

  let drawerWasOpen = false;
  let resetTimer = null;
  let openSectionKeys = new Set();

  function getModal() {
    return document.getElementById(MODAL_ID);
  }

  function getModalContent() {
    const modal = getModal();
    return modal ? modal.querySelector('.snize-modal-content') : null;
  }

  function isDrawerOpen() {
    const modal = getModal();
    if (!modal) return false;

    const style = window.getComputedStyle(modal);

    return (
      style.display !== 'none' &&
      style.visibility !== 'hidden' &&
      modal.offsetHeight > 0
    );
  }

  function isMainHeader(header) {
    return header && header.id === 'snize_filters_block_header';
  }

  function getHeaderKey(header) {
    if (!header) return '';

    if (header.id) return header.id;

    const title = header.querySelector('.snize-product-filters-title');
    return title ? title.textContent.trim() : '';
  }

  function getContainerForHeader(header) {
    if (!header) return null;

    if (header.id) {
      const containerId = header.id.replace(
        'snize_product_filter_header_',
        'snize_product_filter_'
      );

      const containerById = document.getElementById(containerId);

      if (
        containerById &&
        containerById.classList.contains('snize-product-filter-container')
      ) {
        return containerById;
      }
    }

    let nextElement = header.nextElementSibling;

    while (nextElement) {
      if (
        nextElement.classList &&
        nextElement.classList.contains('snize-product-filter-container')
      ) {
        return nextElement;
      }

      if (
        nextElement.classList &&
        nextElement.classList.contains('snize-product-filters-header')
      ) {
        return null;
      }

      nextElement = nextElement.nextElementSibling;
    }

    return null;
  }

  function getHeaderForContainer(container) {
    if (!container) return null;

    if (container.id) {
      const headerId = container.id.replace(
        'snize_product_filter_',
        'snize_product_filter_header_'
      );

      const headerById = document.getElementById(headerId);

      if (
        headerById &&
        headerById.classList.contains('snize-product-filters-header')
      ) {
        return headerById;
      }
    }

    let previousElement = container.previousElementSibling;

    while (previousElement) {
      if (
        previousElement.classList &&
        previousElement.classList.contains('snize-product-filters-header')
      ) {
        return previousElement;
      }

      previousElement = previousElement.previousElementSibling;
    }

    return null;
  }

  function closeSection(header) {
    const container = getContainerForHeader(header);
    if (!container) return;

    const key = getHeaderKey(header);
    if (key) openSectionKeys.delete(key);

    container.classList.remove('ls-snize-filter-open-container');
    header.classList.remove('ls-snize-filter-open');
    header.classList.add('ls-snize-filter-closed');
    header.setAttribute('aria-expanded', 'false');
  }

  function openSection(header) {
    const container = getContainerForHeader(header);
    if (!container) return;

    const key = getHeaderKey(header);
    if (key) openSectionKeys.add(key);

    container.classList.add('ls-snize-filter-open-container');
    header.classList.add('ls-snize-filter-open');
    header.classList.remove('ls-snize-filter-closed');
    header.setAttribute('aria-expanded', 'true');
  }

  function toggleSection(header) {
    const container = getContainerForHeader(header);
    if (!container) return;

    const isOpen = container.classList.contains('ls-snize-filter-open-container');

    if (isOpen) {
      closeSection(header);
    } else {
      openSection(header);
    }
  }

  function closeAllSectionsOnOpen() {
    const modal = getModal();
    if (!modal) return;

    openSectionKeys.clear();

    const headers = modal.querySelectorAll('.snize-product-filters-header');

    headers.forEach(function (header) {
      if (isMainHeader(header)) return;

      const container = getContainerForHeader(header);
      if (!container) return;

      container.classList.remove('ls-snize-filter-open-container');
      header.classList.remove('ls-snize-filter-open');
      header.classList.add('ls-snize-filter-closed');
      header.setAttribute('aria-expanded', 'false');
    });
  }

  function reOpenRememberedSections() {
    const modal = getModal();
    if (!modal) return;
    if (!openSectionKeys.size) return;

    const headers = modal.querySelectorAll('.snize-product-filters-header');

    headers.forEach(function (header) {
      if (isMainHeader(header)) return;

      const key = getHeaderKey(header);

      if (!key || !openSectionKeys.has(key)) return;

      const container = getContainerForHeader(header);
      if (!container) return;

      container.classList.add('ls-snize-filter-open-container');
      header.classList.add('ls-snize-filter-open');
      header.classList.remove('ls-snize-filter-closed');
      header.setAttribute('aria-expanded', 'true');
    });
  }

  function getClosestScrollableElement(target) {
    const modal = getModal();
    if (!modal || !target) return null;

    let element = target.parentElement;

    while (element && element !== modal) {
      const style = window.getComputedStyle(element);

      const canScrollY =
        (style.overflowY === 'auto' || style.overflowY === 'scroll') &&
        element.scrollHeight > element.clientHeight + 5;

      if (canScrollY) {
        return element;
      }

      element = element.parentElement;
    }

    return null;
  }

  function capturePosition(target) {
    const modal = getModal();
    const content = getModalContent();
    const scrollable = getClosestScrollableElement(target);
    const container = target.closest('.snize-product-filter-container');
    const header = getHeaderForContainer(container);

    return {
      headerKey: getHeaderKey(header),
      modalTop: modal ? modal.scrollTop : 0,
      contentTop: content ? content.scrollTop : 0,
      windowY: window.scrollY || window.pageYOffset || 0,
      scrollableTop: scrollable ? scrollable.scrollTop : null
    };
  }

  function findHeaderByKey(key) {
    if (!key) return null;

    const modal = getModal();
    if (!modal) return null;

    const headers = modal.querySelectorAll('.snize-product-filters-header');

    for (const header of headers) {
      if (getHeaderKey(header) === key) {
        return header;
      }
    }

    return null;
  }

  function findScrollableInsideContainer(container) {
    if (!container) return null;

    const elements = [
      container,
      ...Array.from(container.querySelectorAll('*'))
    ];

    for (const element of elements) {
      const style = window.getComputedStyle(element);

      const canScrollY =
        (style.overflowY === 'auto' || style.overflowY === 'scroll') &&
        element.scrollHeight > element.clientHeight + 5;

      if (canScrollY) {
        return element;
      }
    }

    return null;
  }

  function restorePosition(position) {
    if (!position) return;

    const modal = getModal();
    const content = getModalContent();

    if (position.headerKey) {
      openSectionKeys.add(position.headerKey);

      const header = findHeaderByKey(position.headerKey);

      if (header) {
        openSection(header);

        const container = getContainerForHeader(header);
        const scrollable = findScrollableInsideContainer(container);

        if (
          scrollable &&
          position.scrollableTop !== null &&
          typeof position.scrollableTop === 'number'
        ) {
          scrollable.scrollTop = position.scrollableTop;
        }
      }
    }

    reOpenRememberedSections();

    if (modal) modal.scrollTop = position.modalTop;
    if (content) content.scrollTop = position.contentTop;

    window.scrollTo(0, position.windowY);
  }

  function restorePositionAfterSearchanise(position) {
    if (!position) return;

    setTimeout(function () {
      restorePosition(position);
    }, 80);

    setTimeout(function () {
      restorePosition(position);
    }, 220);

    setTimeout(function () {
      restorePosition(position);
    }, 500);

    setTimeout(function () {
      restorePosition(position);
    }, 900);
  }

  function rememberSectionFromOption(target) {
    const modal = getModal();
    if (!modal) return null;

    const container = target.closest('.snize-product-filter-container');
    if (!container || !modal.contains(container)) return null;

    const header = getHeaderForContainer(container);
    if (!header) return null;

    const key = getHeaderKey(header);
    if (key) openSectionKeys.add(key);

    return key;
  }

  function handleOptionTap(target) {
    const modal = getModal();
    if (!modal) return;

    const optionContainer = target.closest('.snize-product-filter-container');
    if (!optionContainer || !modal.contains(optionContainer)) return;

    const position = capturePosition(target);

    rememberSectionFromOption(target);
    restorePositionAfterSearchanise(position);
  }

  function onDrawerOpened() {
    clearTimeout(resetTimer);

    closeAllSectionsOnOpen();

    resetTimer = setTimeout(function () {
      closeAllSectionsOnOpen();
    }, 200);
  }

  function checkDrawerState() {
    const open = isDrawerOpen();

    if (open && !drawerWasOpen) {
      drawerWasOpen = true;
      onDrawerOpened();
    }

    if (!open && drawerWasOpen) {
      drawerWasOpen = false;
      openSectionKeys.clear();
    }
  }

  function checkDrawerStateSoon() {
    setTimeout(checkDrawerState, 80);
    setTimeout(checkDrawerState, 250);
    setTimeout(checkDrawerState, 600);
  }

  document.addEventListener(
    'click',
    function (event) {
      checkDrawerStateSoon();

      const modal = getModal();
      if (!modal) return;

      const optionContainer = event.target.closest('.snize-product-filter-container');

      if (optionContainer && modal.contains(optionContainer)) {
        handleOptionTap(event.target);
        return;
      }

      const header = event.target.closest('.snize-product-filters-header');

      if (!header) return;
      if (!modal.contains(header)) return;
      if (isMainHeader(header)) return;

      const container = getContainerForHeader(header);
      if (!container) return;

      event.preventDefault();
      event.stopPropagation();

      toggleSection(header);
    },
    true
  );

  document.addEventListener(
    'change',
    function (event) {
      const modal = getModal();
      if (!modal) return;
      if (!modal.contains(event.target)) return;

      handleOptionTap(event.target);
    },
    true
  );

  document.addEventListener('touchend', checkDrawerStateSoon, { passive: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkDrawerState);
  } else {
    checkDrawerState();
  }
})();
/* Searchanise top controls bar - fix Target 2 under header */
(function () {
  const HEADER_HEIGHT = 60;

  const path = window.location.pathname;
  const shouldRun =
    path.startsWith('/collections') ||
    path.startsWith('/search') ||
    path === '/pages/shop' ||
    path === '/pages/shop-all' ||
    path === '/pages/search-results-page';

  if (!shouldRun) return;

  let bar = null;
  let placeholder = null;
  let triggerTop = null;
  let isFixed = false;
  let ticking = false;
  let attempts = 0;

  function findBar() {
    const bars = Array.from(document.querySelectorAll('.snize-main-panel'));

    return bars.find(function (el) {
      const rect = el.getBoundingClientRect();

      return rect.width > 100 && rect.height > 20;
    });
  }

  function createPlaceholder() {
    if (!bar || placeholder) return;

    placeholder = document.createElement('div');
    placeholder.setAttribute('data-ls-snize-topbar-placeholder', 'true');
    placeholder.style.display = 'none';
    placeholder.style.height = '0px';

    bar.parentNode.insertBefore(placeholder, bar);
  }

  function calculateTriggerTop() {
    if (!bar) return;

    if (placeholder && isFixed) {
      triggerTop = placeholder.getBoundingClientRect().top + window.pageYOffset;
    } else {
      triggerTop = bar.getBoundingClientRect().top + window.pageYOffset;
    }
  }

  function setImportant(el, prop, value) {
    el.style.setProperty(prop, value, 'important');
  }

  function fixBar() {
    if (!bar || !placeholder || isFixed) return;

    const rect = placeholder.getBoundingClientRect();
    const height = bar.offsetHeight;

    placeholder.style.display = 'block';
    placeholder.style.height = height + 'px';

    setImportant(bar, 'position', 'fixed');
    setImportant(bar, 'top', HEADER_HEIGHT + 'px');
    setImportant(bar, 'left', rect.left + 'px');
    setImportant(bar, 'right', 'auto');
    setImportant(bar, 'width', rect.width + 'px');
    setImportant(bar, 'z-index', '99980');
    setImportant(bar, 'background', '#ffffff');
    setImportant(bar, 'border-bottom', '1px solid rgba(0,0,0,0.08)');
    setImportant(bar, 'box-shadow', '0 3px 10px rgba(0,0,0,0.05)');
    setImportant(bar, 'margin', '0');

    isFixed = true;
  }

  function unfixBar() {
    if (!bar || !placeholder || !isFixed) return;

    placeholder.style.display = 'none';
    placeholder.style.height = '0px';

    [
      'position',
      'top',
      'left',
      'right',
      'width',
      'z-index',
      'background',
      'border-bottom',
      'box-shadow',
      'margin'
    ].forEach(function (prop) {
      bar.style.removeProperty(prop);
    });

    isFixed = false;
    calculateTriggerTop();
  }

  function update() {
    if (!bar || !document.body.contains(bar)) {
      bar = null;
      placeholder = null;
      triggerTop = null;
      isFixed = false;
      setup();
      return;
    }

    if (triggerTop === null) {
      calculateTriggerTop();
    }

    const shouldFix = window.pageYOffset >= triggerTop - HEADER_HEIGHT;

    if (shouldFix) {
      fixBar();

      if (placeholder) {
        const rect = placeholder.getBoundingClientRect();
        setImportant(bar, 'left', rect.left + 'px');
        setImportant(bar, 'width', rect.width + 'px');
      }
    } else {
      unfixBar();
    }
  }

  function requestUpdate() {
    if (ticking) return;

    ticking = true;

    window.requestAnimationFrame(function () {
      update();
      ticking = false;
    });
  }

  function setup() {
    if (bar && document.body.contains(bar)) {
      update();
      return;
    }

    bar = findBar();

    if (!bar) {
      attempts += 1;

      if (attempts <= 30) {
        setTimeout(setup, 300);
      }

      return;
    }

    createPlaceholder();
    calculateTriggerTop();
    update();
  }

  window.addEventListener('scroll', requestUpdate, { passive: true });

  window.addEventListener('resize', function () {
    triggerTop = null;
    requestUpdate();
  });

  document.addEventListener('click', function () {
    setTimeout(setup, 250);
    setTimeout(setup, 800);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setup();
      setTimeout(setup, 500);
      setTimeout(setup, 1500);
      setTimeout(setup, 3000);
    });
  } else {
    setup();
    setTimeout(setup, 500);
    setTimeout(setup, 1500);
    setTimeout(setup, 3000);
  }
})();
/* Add Sort by shortcut next to Searchanise Filters */
(function () {
  const MODAL_ID = 'snize-modal-mobile-filters-dialog';

  const path = window.location.pathname;
  const shouldRun =
    path.startsWith('/collections') ||
    path.startsWith('/search') ||
    path === '/pages/shop' ||
    path === '/pages/shop-all' ||
    path === '/pages/search-results-page';

  if (!shouldRun) return;

  let setupTimer = null;

  function scheduleSetup(delay) {
    clearTimeout(setupTimer);

    setupTimer = setTimeout(function () {
      addSortShortcut();
    }, delay || 150);
  }

  function getSearchaniseBars() {
    return Array.from(document.querySelectorAll('.snize-main-panel')).filter(function (bar) {
      const rect = bar.getBoundingClientRect();
      return rect.width > 100 && rect.height > 20;
    });
  }

  function findFiltersTrigger(bar) {
    if (!bar) return null;

    const preferred =
      bar.querySelector('.snize-main-panel-mobile-filters a') ||
      bar.querySelector('.snize-main-panel-mobile-filters button');

    if (preferred) return preferred;

    const controls = Array.from(bar.querySelectorAll('a, button'));

    return controls.find(function (control) {
      return control.textContent && control.textContent.trim().toLowerCase().includes('filters');
    });
  }

  function getContainerForHeader(header) {
    if (!header) return null;

    if (header.id) {
      const containerId = header.id.replace(
        'snize_product_filter_header_',
        'snize_product_filter_'
      );

      const containerById = document.getElementById(containerId);

      if (
        containerById &&
        containerById.classList.contains('snize-product-filter-container')
      ) {
        return containerById;
      }
    }

    let nextElement = header.nextElementSibling;

    while (nextElement) {
      if (
        nextElement.classList &&
        nextElement.classList.contains('snize-product-filter-container')
      ) {
        return nextElement;
      }

      if (
        nextElement.classList &&
        nextElement.classList.contains('snize-product-filters-header')
      ) {
        return null;
      }

      nextElement = nextElement.nextElementSibling;
    }

    return null;
  }

  function findSortHeader() {
    const modal = document.getElementById(MODAL_ID);
    if (!modal) return null;

    const direct =
      document.getElementById('snize_product_filter_header_mobile_sort') ||
      document.getElementById('snize_product_filter_header_sort');

    if (direct) return direct;

    const headers = Array.from(modal.querySelectorAll('.snize-product-filters-header'));

    return headers.find(function (header) {
      const text = header.textContent ? header.textContent.trim().toLowerCase() : '';
      return text.includes('sort');
    });
  }

  function closeOtherSections(sortHeader) {
    const modal = document.getElementById(MODAL_ID);
    if (!modal) return;

    const headers = modal.querySelectorAll('.snize-product-filters-header');

    headers.forEach(function (header) {
      if (header === sortHeader) return;
      if (header.id === 'snize_filters_block_header') return;

      const container = getContainerForHeader(header);
      if (!container) return;

      container.classList.remove('ls-snize-filter-open-container');
      header.classList.remove('ls-snize-filter-open');
      header.classList.add('ls-snize-filter-closed');
      header.setAttribute('aria-expanded', 'false');
    });
  }

  function openSortAccordion() {
    const sortHeader = findSortHeader();
    if (!sortHeader) return;

    const container = getContainerForHeader(sortHeader);
    if (!container) return;

    closeOtherSections(sortHeader);

    container.classList.add('ls-snize-filter-open-container');
    sortHeader.classList.add('ls-snize-filter-open');
    sortHeader.classList.remove('ls-snize-filter-closed');
    sortHeader.setAttribute('aria-expanded', 'true');

    setTimeout(function () {
      sortHeader.scrollIntoView({
        block: 'start',
        behavior: 'smooth'
      });
    }, 80);
  }

  function openFiltersThenSort() {
    const bars = getSearchaniseBars();
    const bar = bars[0];
    const filtersTrigger = findFiltersTrigger(bar);

    if (!filtersTrigger) return;

    filtersTrigger.click();

    setTimeout(openSortAccordion, 250);
    setTimeout(openSortAccordion, 500);
    setTimeout(openSortAccordion, 900);
  }

  function addSortShortcutToBar(bar) {
    if (!bar) return;

    if (bar.querySelector('.ls-snize-sort-shortcut')) {
      bar.classList.add('ls-snize-has-sort-shortcut');
      return;
    }

    const filtersTrigger = findFiltersTrigger(bar);
    if (!filtersTrigger) return;

    const sortButton = document.createElement('button');
    sortButton.type = 'button';
    sortButton.className = 'ls-snize-sort-shortcut';
    sortButton.textContent = 'Sort by';

    sortButton.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();

      openFiltersThenSort();
    });

    const filtersWrapper =
      filtersTrigger.closest('.snize-main-panel-mobile-filters') ||
      filtersTrigger.parentElement;

    if (filtersWrapper && filtersWrapper.parentNode) {
      filtersWrapper.parentNode.insertBefore(sortButton, filtersWrapper);
    } else {
      bar.insertBefore(sortButton, bar.firstChild);
    }

    bar.classList.add('ls-snize-has-sort-shortcut');
  }

  function addSortShortcut() {
    const bars = getSearchaniseBars();

    bars.forEach(function (bar) {
      addSortShortcutToBar(bar);
    });
  }

  function runSetupBurst() {
    scheduleSetup(100);
    setTimeout(addSortShortcut, 350);
    setTimeout(addSortShortcut, 800);
    setTimeout(addSortShortcut, 1500);
  }

  document.addEventListener('DOMContentLoaded', runSetupBurst);
  window.addEventListener('pageshow', runSetupBurst);
  window.addEventListener('popstate', runSetupBurst);
  window.addEventListener('hashchange', runSetupBurst);

  document.addEventListener('click', function (event) {
    const clickedSearchanise =
      event.target.closest('.snize-pagination') ||
      event.target.closest('.snize-main-panel') ||
      event.target.closest('#snize_results') ||
      event.target.closest('[class*="snize"]');

    if (clickedSearchanise) {
      runSetupBurst();
    }
  });

  const observer = new MutationObserver(function (mutations) {
    const searchaniseChanged = mutations.some(function (mutation) {
      return Array.from(mutation.addedNodes).some(function (node) {
        if (!node || node.nodeType !== 1) return false;

        return (
          node.classList?.contains('snize-main-panel') ||
          node.querySelector?.('.snize-main-panel') ||
          node.id === 'snize_results' ||
          node.querySelector?.('#snize_results') ||
          node.className?.toString().includes('snize')
        );
      });
    });

    if (searchaniseChanged) {
      scheduleSetup(150);
      setTimeout(addSortShortcut, 600);
      setTimeout(addSortShortcut, 1200);
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  runSetupBurst();
})();